import {
  Button,
  Flex,
  HStack,
  Image,
  Input,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef, useState, useEffect, useCallback } from "react";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import ActionButton from "@arcgis/core/support/actions/ActionButton";

import ArcgisHelper from "../arcgis/ArcgisHelper";
import { DinhGiaThuaLienKe, Kvhc, ThongTinGiaDat } from "../components";
import KvhcDatasource from "../_mocks_/kvhc.json";
import { IDisplayGeo, IDropdownItem, IThuaDatIdentity } from "../_types_";
import { useSelectedGeometries } from "../hook";
import { useNavigate } from "react-router-dom";
import DinhGiaFromFile from "../components/DinhGiaThuaFromFile";

export default function MapPage() {
  const navigate = useNavigate();

  const [searchVal, setSearchVal] = useState<string>();
  const mapRef = useRef() as any;
  const [arc, setArc] = useState<ArcgisHelper>();

  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isOpenThuaLienKe,
    onClose: onCloseThuaLienKe,
    onOpen: onOpenThuaLienKe,
  } = useDisclosure();
  const {
    isOpen: isOpenThuaFile,
    onClose: onCloseThuaFile,
    onOpen: onOpenThuaFile,
  } = useDisclosure();

  const [currentThuaDat, setCurrentThuaDat] = useState<IThuaDatIdentity>();
  //thua liền kề
  const [currentThuaDatLienKe, setCurrentThuaDatLienKe] =
    useState<IThuaDatIdentity>();

  //thửa from file
  const [currentThuaDatFromFile, setCurrentThuaDatFromFile] =
    useState<IThuaDatIdentity>();

  const [geometries, setSelectedGeometries] =
    useSelectedGeometries(currentThuaDat);

  const [huyenSelected, setMaHuyen] = useState<string | number>();
  const [xaSelected, setMaXa] = useState<string | number>();
  const [geoFromFile, setGeoFromFile] = useState<IDisplayGeo[]>();

  const [kvhcCapHuyen] = useState<IDropdownItem[]>(() => {
    const huyenS = KvhcDatasource.map((kv) => {
      const item: IDropdownItem = {
        lable: kv.tenHuyen,
        value: kv.maHuyen,
      };
      return item;
    });
    setMaHuyen(huyenS[1].value);
    return huyenS;
  });
  const [kvhcCapXa, setKvhcCapXa] = useState<IDropdownItem[]>([]);

  const handleViewFieldDetail = useCallback(
    async (soTo: string, soThua: string) => {
      try {
        if (!huyenSelected || !xaSelected) return;
        // let chiTiet = await getPriceHistory(
        //   huyenSelected.toString(),
        //   xaSelected.toString(),
        //   soTo,
        //   soThua
        // );
        // console.log({ chiTiet });
        onOpen();
      } catch (er) {
        //toast(getToast(`${er}`))
      }
    },
    [huyenSelected, onOpen, xaSelected]
  );

  const hanldeXacDinhTheoThuaLienKe = () => {
    onClose();
    onOpenThuaLienKe();
  };
  const hanldeThuaFile = () => {
    onClose();
    onOpenThuaFile();
  };

  const init = useCallback(async () => {
    if (!huyenSelected || !xaSelected) return;
    const arc1 = new ArcgisHelper(
      mapRef.current,
      huyenSelected.toString(),
      xaSelected.toString()
    );
    setArc(arc1);
    await arc1.init();
    const initView = arc1.initializeMap();
    //setView(initView);
    initView.on("click", async function (event) {
      try {
        // if (xaSelected !== "26560") {
        //   alert("Chưa xây dựng cơ sở dữ liệu");
        //   return;
        // }
        const graphicClicked = await arc1.queryFeatureLayer(
          event.mapPoint,
          0,
          "within"
        );
        const thuaDat = graphicClicked.attributes;
        const { SoHieuToBanDo, SoThuTuThua, DienTich, KyHieuMucDichSuDung } =
          thuaDat;

        const measureThisAction = new ActionButton({
          title: "Thông tin giá đất",
          id: "xem-thong-tin-gia-dat",
          image:
            "https://developers.arcgis.com/javascript/latest/sample-code/popup-actions/live/Measure_Distance16.png",
        });

        const thuaLienKeAction = new ActionButton({
          title: "Định giá theo thửa liền kề",
          id: "dinh-gia-theo-thua-lien-ke",
          image:
            "https://developers.arcgis.com/javascript/latest/sample-code/popup-actions/live/Measure_Distance16.png",
        });

        const addSharpFile = new ActionButton({
          title: "Thêm shape file",
          id: "add-shape-file",
          image:
            "https://developers.arcgis.com/javascript/latest/sample-code/popup-actions/live/Measure_Distance16.png",
        });

        const popupTemplate = new PopupTemplate({
          actions: [],
        });

        popupTemplate.content = `<div>
          <table class='tbl-thua-dat-info'>
            <tr>
              <td>Số tờ</td>
              <th>${SoHieuToBanDo}</th>
              <td>Số thửa</td>
              <th>${SoThuTuThua}</th>
              <td>Diện tích</td>
              <th>${DienTich} m2</th>
            </tr>
            <tr>
              <td>MĐSD</td>
              <th colspan="5">${KyHieuMucDichSuDung}</th>
            </tr>            
          </table>         
        </div>`;
        popupTemplate.actions.push(measureThisAction);
        popupTemplate.actions.push(thuaLienKeAction);
        popupTemplate.actions.push(addSharpFile);

        popupTemplate.title = "Thông Tin Thửa Đất";
        // if (xaSelected !== "26560") {
        //   popupTemplate.actions.removeAll();
        // }
        graphicClicked.popupTemplate = popupTemplate;

        initView.popup.viewModel.includeDefaultActions = false;
        initView.popup.open({
          location: event.mapPoint,
          features: [graphicClicked],
        });

        initView.popup.on("trigger-action", (event) => {
          if (event.action.id === "xem-thong-tin-gia-dat") {
            handleViewFieldDetail(SoHieuToBanDo, SoThuTuThua);
            setCurrentThuaDat({
              soThua: SoThuTuThua,
              soTo: SoHieuToBanDo,
              maXa: xaSelected.toString(),
              maHuyen: huyenSelected.toString(),
            });
          } else if (event.action.id === "dinh-gia-theo-thua-lien-ke") {
            hanldeXacDinhTheoThuaLienKe();
            setCurrentThuaDatLienKe({
              soThua: SoThuTuThua,
              soTo: SoHieuToBanDo,
              maXa: xaSelected.toString(),
              maHuyen: huyenSelected.toString(),
            });
          } else if (event.action.id === "add-shape-file") {
            hanldeThuaFile();
            setCurrentThuaDatFromFile({
              soThua: SoThuTuThua,
              soTo: SoHieuToBanDo,
              maXa: xaSelected.toString(),
              maHuyen: huyenSelected.toString(),
            });
          }
        });
      } catch (er) {
        console.log({ er });
      }
    });
  }, [handleViewFieldDetail, huyenSelected, xaSelected]);

  useEffect(() => {
    if (huyenSelected) {
      const huyen = KvhcDatasource.find((p) => p.maHuyen === huyenSelected);
      const xaS = !huyen
        ? []
        : huyen.xas.map((xa) => {
            const item: IDropdownItem = {
              lable: xa.tenXa,
              value: xa.maXa,
            };
            return item;
          });
      setKvhcCapXa(xaS);
      setMaXa(xaS[0].value);
    }
  }, [huyenSelected]);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    try {
      if (!arc) return;
      arc.drawGeometries(geometries);
    } catch (er) {}
  }, [arc, geometries]);

  const handleSearch = async () => {
    try {
      if (!arc || !searchVal) return;

      const toThua = searchVal.split("/");
      if (toThua.length > 1) {
        await arc.searchByToThua(toThua[0], toThua[1]);
      } else {
        await arc.searchByTenDuong(searchVal);
      }
    } catch (er) {
      console.log("lỗi tìm kiếm", er);
    }
  };
  useEffect(() => {
    try {
      if (!arc || !geoFromFile) return;
      arc.drawGeometries(geoFromFile);
    } catch (er) {
      console.log("lỗi tìm kiếm", er);
    }
  }, [arc, geoFromFile]);

  //set xã default
  return (
    <Flex w="full">
      <Flex as="div" className="mapDiv" ref={mapRef}></Flex>
      <HStack as="div" position="absolute" left="100px" top="20px">
        <HStack>
          <Kvhc
            data={kvhcCapHuyen}
            selectedValue={huyenSelected}
            defaultLabel="--- Chọn huyện/thành phố ---"
            onValueChange={(val) => setMaHuyen(val)}
          />
          <Kvhc
            data={kvhcCapXa}
            selectedValue={xaSelected}
            defaultLabel="--- Chọn phường/quận ---"
            onValueChange={(val) => setMaXa(val)}
          />
        </HStack>
        <HStack bg="white" border="1px solid #f1f1f1">
          <HStack px="10px" bg="white">
            <Input
              _focusVisible={{ outline: "none" }}
              border="none"
              value={searchVal}
              placeholder="Tờ/thửa hoặc tên đường"
              onChange={(e) => setSearchVal(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearch();
              }}
              color="#333"
            />
          </HStack>
          <Flex onClick={handleSearch} px="20px" py="10px" cursor="pointer">
            <Image src="./imgs/search.svg" alt="search" />
          </Flex>
        </HStack>
      </HStack>

      <Button
        bg="white"
        position="absolute"
        right="50px"
        top="20px"
        onClick={() => navigate("/bang-gia-dat")}
      >
        <Image src="./imgs/menu.svg" />
      </Button>

      <VStack as="div" position="absolute" left="100px" top="80px">
        <Text
          fontSize="18px"
          fontWeight="bold"
          //backgroundColor="white"
          padding="2px"
          color="darkblue"
        >
          {`Bản đồ giá đất ${
            kvhcCapXa.find((f) => f.value === xaSelected)?.lable
          }, ${
            kvhcCapHuyen.find((f) => f.value === huyenSelected)?.lable
          }`}{" "}
          kỳ 2023 - 2025
        </Text>
      </VStack>
      <ThongTinGiaDat
        isOpen={isOpen}
        onClose={onClose}
        soTo={currentThuaDat?.soTo ?? 0}
        soThua={currentThuaDat?.soThua ?? 0}
        maHuyen={currentThuaDat?.maHuyen ?? ""}
        maXa={currentThuaDat?.maXa ?? ""}
        setSelectedGeometries={setSelectedGeometries}
      />

      <DinhGiaThuaLienKe
        isOpen={isOpenThuaLienKe}
        onClose={onCloseThuaLienKe}
        soTo={currentThuaDatLienKe?.soTo ?? 0}
        soThua={currentThuaDatLienKe?.soThua ?? 0}
        maHuyen={currentThuaDatLienKe?.maHuyen ?? ""}
        maXa={currentThuaDatLienKe?.maXa ?? ""}
        setSelectedGeometries={setSelectedGeometries}
      />

      <DinhGiaFromFile
        setSelectedGeometries={setSelectedGeometries}
        arc={arc}
        isOpen={isOpenThuaFile}
        onClose={onCloseThuaFile}
        soTo={currentThuaDatFromFile?.soTo || 0}
        soThua={currentThuaDatFromFile?.soThua || 0}
        maHuyen={huyenSelected?.toString() || ""}
        maXa={xaSelected?.toString() || ""}
      ></DinhGiaFromFile>
    </Flex>
  );
}
